import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Box, Button, Typography } from "@mui/material";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";

export default function CaptureSession({ component: Component }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const identity = JSON.stringify([params.get("convocatoriaId") || location.state?.convocatoriaId || "", params.get("uuid") || ""]);
  return <Session key={identity} component={Component} />;
}

function Session({ component: Component }) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const previous = location.state?.saludV2Saved;
  const [saved, setSaved] = useState(() => !params.get("uuid") &&
    String(previous?.convocatoriaId) === params.get("convocatoriaId") ? previous : null);
  const [generation, setGeneration] = useState(0);
  const [navigation, setNavigation] = useState({ busy: true, uncertain: false, dirty: false });
  const onNavigationState = useCallback(next => setNavigation(previous =>
    previous.busy === next.busy && previous.uncertain === next.uncertain && previous.dirty === next.dirty ? previous : next), []);
  const onCreated = useCallback(receipt => {
    setSaved(receipt);
    setGeneration(value => value + 1);
    navigate(`${location.pathname}?convocatoriaId=${receipt.convocatoriaId}`, {
      replace: true, state: { convocatoriaId: receipt.convocatoriaId, saludV2Saved: receipt },
    });
  }, [location.pathname, navigate]);
  const openSaved = () => {
    if (navigation.busy || navigation.uncertain) return;
    if (navigation.dirty && !window.confirm("Hay cambios sin guardar. ¿Desea descartarlos?")) return;
    navigate(`${location.pathname}?convocatoriaId=${saved.convocatoriaId}&uuid=${saved.id}`);
  };
  return <>
    {saved && <Box sx={{ m: 2 }}><Alert severity="success" sx={{ overflowWrap: "anywhere", "& .MuiAlert-message": { minWidth: 0 } }}
      action={<Button size="small" startIcon={<FolderOpenOutlinedIcon />} disabled={navigation.busy || navigation.uncertain} onClick={openSaved}>Abrir atención guardada</Button>}>
      Atención guardada. Estado: pendiente.
      <Typography variant="caption" component="div">UUID: {saved.id} · versión {saved.version}</Typography>
    </Alert></Box>}
    <Component key={generation} onCreated={onCreated} onNavigationState={onNavigationState} />
  </>;
}
